import { render, staticRenderFns } from "./ServersTableComponent.vue?vue&type=template&id=1411aebb&scoped=true&"
import script from "./ServersTableComponent.vue?vue&type=script&lang=js&"
export * from "./ServersTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServersTableComponent.vue?vue&type=style&index=0&id=1411aebb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1411aebb",
  null
  
)

export default component.exports